var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSofaProdutoImobiliario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_838_15300",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.350586,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_838_15300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.76923 18.3505H4.23078L3.85 16.3505H3V12.9601C3 12.5126 3.15737 12.1325 3.4721 11.8197C3.78685 11.5069 4.16794 11.3505 4.61538 11.3505H5V8.96584C5 8.51841 5.15737 8.13731 5.4721 7.82256C5.78685 7.50783 6.16794 7.35046 6.61537 7.35046H17.3846C17.8321 7.35046 18.2132 7.50783 18.5279 7.82256C18.8426 8.13731 19 8.51841 19 8.96584V11.3505H19.3846C19.8321 11.3505 20.2132 11.5078 20.5279 11.8226C20.8426 12.1373 21 12.5184 21 12.9658V16.3505H20.15L19.7692 18.3505H19.2308L18.85 16.3505H5.15L4.76923 18.3505ZM12.5 11.3505H18V8.96584C18 8.78636 17.9423 8.63892 17.8269 8.52354C17.7115 8.40815 17.5641 8.35046 17.3846 8.35046H12.5V11.3505ZM6 11.3505H11.5V8.35046H6.61537C6.43589 8.35046 6.28846 8.40815 6.17308 8.52354C6.05769 8.63892 6 8.78636 6 8.96584V11.3505ZM4 15.3505H20V12.9658C20 12.7864 19.9423 12.6389 19.8269 12.5235C19.7115 12.4082 19.5641 12.3505 19.3846 12.3505H4.61538C4.43589 12.3505 4.28846 12.4082 4.17308 12.5235C4.05769 12.6389 4 12.7864 4 12.9658V15.3505Z",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofaProdutoImobiliario);
export default __webpack_public_path__ + "static/media/sofa-produto-imobiliario.547e1b02f8e332670d2157fff77b626d.svg";
export { ForwardRef as ReactComponent };